import { render, staticRenderFns } from "./StudentSpecialAttendance.vue?vue&type=template&id=15bed186"
import script from "./StudentSpecialAttendance.vue?vue&type=script&lang=js"
export * from "./StudentSpecialAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports